import { Sprite } from "../display/Sprite";
import { Texture } from "../resource/Texture";
import { Event } from "../events/Event";
import { LayaEnv } from "../../LayaEnv";
import { PAL } from "../platform/PlatformAdapters";
export class VideoNode extends Sprite {
    constructor() {
        super();
        this.options = { controls: false, objectFit: "contain" };
        this.mode = "decoder";
        this._autoPlay = false;
        this._loop = false;
        this._volume = 1;
        this._muted = false;
        this._playbackRate = 1;
        this._allowBackground = false;
        this._paused = false;
        this.on(Event.DISPLAY, this, this.onDisplay);
        this.on(Event.UNDISPLAY, this, this.onUndisplay);
    }
    get player() {
        return this._api;
    }
    get source() {
        return this._source;
    }
    set source(value) {
        this._source = value;
        if (value) {
            if (this.activeInHierarchy)
                this._load();
        }
        else
            this._unload();
    }
    get autoPlay() {
        return this._autoPlay;
    }
    set autoPlay(value) {
        this._autoPlay = value;
        if (this._api && LayaEnv.isPlaying)
            value ? this._api.play() : this._api.pause();
    }
    get allowBackground() {
        return this._allowBackground;
    }
    set allowBackground(value) {
        this._allowBackground = value;
        if (this._api)
            this._api.allowBackground = value;
    }
    get currentTime() {
        var _a;
        return (_a = this._api) === null || _a === void 0 ? void 0 : _a.currentTime;
    }
    set currentTime(value) {
        if (!this._api)
            return;
        this._api.currentTime = value;
    }
    get readyState() {
        var _a, _b;
        return (_b = (_a = this._vtex) === null || _a === void 0 ? void 0 : _a.readyState) !== null && _b !== void 0 ? _b : 0;
    }
    get videoWidth() {
        var _a;
        return (_a = this._vtex) === null || _a === void 0 ? void 0 : _a.videoWidth;
    }
    get videoHeight() {
        var _a;
        return (_a = this._vtex) === null || _a === void 0 ? void 0 : _a.videoHeight;
    }
    get duration() {
        var _a;
        return (_a = this._api) === null || _a === void 0 ? void 0 : _a.duration;
    }
    get ended() {
        var _a;
        return (_a = this._api) === null || _a === void 0 ? void 0 : _a.ended;
    }
    get loop() {
        return this._loop;
    }
    set loop(value) {
        this._loop = value;
        if (this._api)
            this._api.loop = value;
    }
    get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(value) {
        this._playbackRate = value;
        if (this._api)
            this._api.playbackRate = value;
    }
    get volume() {
        return this._volume;
    }
    set volume(value) {
        this._volume = value;
        if (this._api)
            this._api.volume = value;
    }
    get muted() {
        return this._muted;
    }
    set muted(value) {
        this._muted = value;
        if (this._api)
            this._api.muted = value;
    }
    get paused() {
        return this._paused;
    }
    load(url) {
        this.source = url;
    }
    play() {
        if (!this._api)
            return;
        this._api.play();
    }
    pause() {
        this._paused = true;
        if (this._api)
            this._api.pause();
    }
    reload() {
        this.source = this._source;
    }
    canPlayType(type) {
        return PAL.media.canPlayType(type);
    }
    _load() {
        let player;
        let vt;
        let backendType = LayaEnv.isPlaying ? this.mode : "decoder";
        if (backendType === "player") {
            player = (this._player || PAL.media.createVideoPlayer());
            if (!player)
                vt = PAL.media.createVideoTexture();
        }
        else {
            vt = (this._vtex || PAL.media.createVideoTexture());
            if (!vt)
                player = PAL.media.createVideoPlayer();
        }
        if (player) {
            if (this._player !== player) {
                this._player = player;
                this._player.attachTo(this);
                this._player.options = this.options;
            }
            if (this._vtex) {
                this._vtex.destroy();
                this._vtex = null;
                this.texture = null;
            }
        }
        else {
            if (this._vtex !== vt) {
                this._vtex = vt;
                this._vtex.on(Event.READY, this, this._vtReady);
                this._vtex.on("videoUpdate", this, this.reCache);
                if (!this._tex)
                    this.texture = this._tex = new Texture();
            }
            if (this._player) {
                this._player.destroy();
                this._player = null;
            }
        }
        this._api = player || vt;
        this._api.loop = this._loop;
        this._api.volume = this._volume;
        this._api.muted = this._muted;
        this._api.playbackRate = this._playbackRate;
        this._api.allowBackground = this._allowBackground;
        if (this._autoPlay && !this._paused && LayaEnv.isPlaying)
            this._api.play();
        else
            this._api.pause();
        this._api.load(this._source);
    }
    _vtReady() {
        this._tex.setTo(this._vtex);
        this.graphics.repaint();
    }
    _unload() {
        var _a;
        if (this._vtex) {
            this._vtex.off(Event.READY, this, this._vtReady);
            this._vtex.off("videoUpdate", this, this.reCache);
            this._vtex.destroy();
            this._vtex = null;
        }
        (_a = this._player) === null || _a === void 0 ? void 0 : _a.destroy();
        this._player = null;
        this._api = null;
    }
    onDisplay() {
        if (!this._api && this._source)
            this._load();
    }
    onUndisplay() {
        this._unload();
    }
    destroy(detroyChildren = true) {
        this._unload();
        super.destroy(detroyChildren);
    }
    get currentSrc() {
        return this._source;
    }
    get videoTexture() {
        return this._vtex;
    }
    set videoTexture(value) {
        if (value)
            this.source = value.source;
        else
            this.source = null;
    }
}
